module.exports = __webpack_public_path__ + "img/g2.94e60a0c.png";